import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Card, Typography } from "@mui/material";
import NoDataLabel from "../../../components/common/NoDataLabel";

const generateField = (row) => {
  if (
    row.fieldValue !== null &&
    row.fieldValue !== undefined &&
    row.fieldValue !== ""
  ) {
    return <Typography>{row.fieldValue}</Typography>;
  }
  return <NoDataLabel />;
};

export default function ClientInfo({ rows }) {
  return (
    <Card variant="outlined">
      <TableContainer sx={{ maxWidth: "100%" }} component={Paper}>
        <Table sx={{ maxWidth: "100%" }} aria-label="simple table">
          <TableBody>
            {rows?.length > 0 &&
              rows?.map((row) => (
                <TableRow
                  key={row.fieldName}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ padding: "5px !important;" }}
                  >
                    <b className="app_text_color">{`${row.fieldName}:`}</b>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: "5px !important;" }}>
                    {generateField(row)}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
